module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "integrations"
    }
  }, [_c('div', [_c('mu-card-header', {
    attrs: {
      "titleClass": "boldTitle largeTitle",
      "title": _vm.title,
      "subTitle": _vm.subTitle
    }
  }), _vm._v(" "), _c('mu-card-text', {
    staticClass: "integration-panel"
  }, _vm._l((_vm.integrations), function(integration, index) {
    return _c('mu-row', {
      key: 'integration-' + index,
      staticClass: "integration-item",
      class: {
        bottom: _vm.bottom
      },
      attrs: {
        "gutter": ""
      }
    }, [_c('mu-col', {
      staticStyle: {
        "position": "relative"
      },
      attrs: {
        "width": "100",
        "desktop": "10",
        "tablet": "10"
      }
    }, [_c('img', {
      attrs: {
        "src": integration.image,
        "width": "100%"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "check",
      staticStyle: {
        "position": "absolute"
      }
    }, [_c('mu-icon', {
      attrs: {
        "color": "white",
        "value": "check"
      }
    })], 1)]), _vm._v(" "), _c('mu-col', {
      attrs: {
        "width": "100",
        "desktop": "90",
        "tablet": "90"
      }
    }, [_c('div', {
      staticClass: "title",
      domProps: {
        "textContent": _vm._s(integration.title)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "afterText",
      domProps: {
        "textContent": _vm._s(integration.description)
      }
    }), _vm._v(" "), (!_vm.subscribedTo(integration.key)) ? _c('div', [_c('mu-raised-button', {
      attrs: {
        "label": _vm.$t('message.connectText')
      },
      nativeOn: {
        "click": function($event) {
          return _vm.windowOpen(integration.url, integration.key, integration.cookie, integration.handshake)
        }
      }
    })], 1) : _c('div', [_c('mu-raised-button', {
      attrs: {
        "background-color": "red",
        "color": "white",
        "label": _vm.$t('message.disconnectText')
      },
      nativeOn: {
        "click": function($event) {
          return _vm.disconnectIntegration(integration.key)
        }
      }
    }), _vm._v(" "), (integration.syncsHeartRate) ? _c('mu-raised-button', {
      attrs: {
        "disabled": _vm.hasStriivSyncStarted || _vm.isStriivPending || _vm.isStriivPending,
        "label": _vm.isStriivPending === true ? 'Sync is already processing' : 'Sync readings'
      },
      nativeOn: {
        "click": function($event) {
          return _vm.syncStriivHeartRate.apply(null, arguments)
        }
      }
    }) : _vm._e()], 1)])], 1)
  }), 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f0afe73","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Settings/Integrations.vue
// module id = 3718
// module chunks = 1